import BaseModel from "./BaseModel";
import {getDocs, limit, orderBy, query, startAfter, where, Timestamp} from "firebase/firestore";
import { auth } from '../firebase'
import ShopifyProduct from "./ShopifyProduct";

export default class SocialPost extends BaseModel {
    static data_name = 'social_posts';

    static async latestPost(){
        let q = query(this.collectionRef, orderBy("index", "desc"), limit(1));

        const querySnapshot = await getDocs(q);

        let next_index = 1

        if(querySnapshot.docs.length > 0) {
            let social_post = this.instanceFromDocument(querySnapshot.docs[0]);
            if(social_post.published){
                next_index = social_post.index + 1
            } else {
                return social_post;
            }
        }

        let instance = new this();
        instance.index = next_index;
        instance.document_id = next_index.toString();
        instance.created_at = Timestamp.now();
        instance.published_at = new Date();
        instance.published = false;
        instance.title = "";
        instance.description = "";
        instance.tags = "";
        instance.posted_to_instagram = false;
        instance.posted_to_facebook = false;
        instance.posted_to_youtube = false;
        instance.youtube_id = "";
        instance.instagram_url = "";
        instance.tiktok_url = "";
        instance.posted_to_tiktok = false;
        instance.user = auth.currentUser.email;
        instance.audio = ""
        instance.product_ids = [];
        await instance.save();
        return instance;
    }

    async addProduct(product){
        this.product_ids.push({ product_document_id: product.document_id, image_index: product.main_image_index });
        await this.save();
    }

    async removeProduct(product){
        this.product_ids = this.product_ids.filter( u => u.product_document_id != product.document_id);
        await this.save();
    }

    async moveProduct(from_index, to_index){
        console.log("move from ", from_index, to_index);
        let item = this.product_ids[from_index];
        this.product_ids.splice(from_index, 1);
        this.product_ids.splice(to_index, 0, item);
        await this.save();
    }

    async setInstagramPostID(post_id){
        this.instagram_post_id = post_id;
        this.posted_to_instagram = true;
        await this.save();
    }

    get product_document_ids(){
        return this.product_ids.map( u => u.product_document_id);
    }

    async products(){
        if(this.product_ids.length < 1) return [];
        let ids = this.product_document_ids;

        let all_ids = [...ids]
        let id_groups = []
        let group_size = 10;

        while (all_ids.length > 0) {
            id_groups.push(all_ids.splice(0, group_size));
        }

        console.log(id_groups);

        let products = []
        for(let id_array of id_groups){
            let results = await ShopifyProduct.getForDocumentIDs(id_array);
            products = products.concat(results);
        }

        //return products.sort( (a, b) => ids.indexOf(a.document_id) - ids.indexOf(b.document_id));

        let output = []
        for(let id of this.product_ids){
            let index = products.findIndex( u => u.document_id == id.product_document_id );
            if(index >= 0) {
                console.log("id", id.product_document_id, index, index > -1 ? products[index].handle : '');
                output.push(products[index]);
                products.splice(index, 1);
            } else {
                let product = output.find( u => u.document_id == id.product_document_id );
                if(product){
                    output.push(product)
                }
            }
        }
        return output;
    }
}